// ParentsPage-v2.0.0.jsx - Version: 2.0.0 - Created: 2024-12-08
import React, { useState } from 'react'
import './ParentsPage-v2.0.0.css'

const ParentsPage = () => {
  const [activeTab, setActiveTab] = useState('overview')
  const [timeLimit, setTimeLimit] = useState(60)
  const [notifications, setNotifications] = useState(true)
  const [weeklyReports, setWeeklyReports] = useState(true)

  const children = [
    {
      id: 1,
      name: 'علی',
      age: 8,
      level: 'مبتدی',
      progress: 65,
      lastActive: '۲ ساعت پیش',
      avatar: '👦',
      joinedDate: '۱۴۰۲/۰۹/۰۱'
    },
    {
      id: 2,
      name: 'سارا',
      age: 10,
      level: 'متوسط',
      progress: 42,
      lastActive: '۱ روز پیش',
      avatar: '👧',
      joinedDate: '۱۴۰۲/۰۸/۱۵'
    }
  ]

  const achievements = [
    { 
      id: 1, 
      title: 'تکمیل ۱۰ درس', 
      date: '۱۴۰۲/۰۹/۱۷', 
      child: 'علی',
      icon: '📚',
      points: 100
    },
    { 
      id: 2, 
      title: 'کسب نشان طلا', 
      date: '۱۴۰۲/۰۹/۱۵', 
      child: 'سارا',
      icon: '🏆',
      points: 50
    },
    { 
      id: 3, 
      title: 'پازل‌های پی در پی', 
      date: '۱۴۰۲/۰۹/۱۴', 
      child: 'علی',
      icon: '🧩',
      points: 75
    },
    { 
      id: 4, 
      title: 'برد در تورنمنت', 
      date: '۱۴۰۲/۰۹/۱۲', 
      child: 'سارا',
      icon: '⚔️',
      points: 150
    }
  ]

  const weeklyReportsData = [
    {
      week: 'هفته جاری',
      studyTime: '۴ ساعت و ۲۰ دقیقه',
      lessonsCompleted: 8,
      gamesPlayed: 12,
      puzzlesSolved: 15,
      improvement: '+۱۵٪'
    },
    {
      week: 'هفته گذشته',
      studyTime: '۳ ساعت و ۴۵ دقیقه',
      lessonsCompleted: 6,
      gamesPlayed: 10,
      puzzlesSolved: 12,
      improvement: '+۸٪'
    }
  ]

  const progressData = {
    labels: ['شهریور', 'مهر', 'آبان', 'آذر'],
    lessons: [12, 18, 25, 32],
    games: [8, 12, 15, 20],
    puzzles: [15, 22, 30, 42]
  }

  const handleAddChild = () => {
    const childName = prompt('نام کودک جدید را وارد کنید:')
    if (childName) {
      alert(`کودک "${childName}" با موفقیت اضافه شد!`)
    }
  }

  const handleViewDetails = (child) => {
    setActiveTab('child-' + child.id)
  }

  const renderOverview = () => (
    <div className="overview-content">
      {/* کارت‌های خلاصه */}
      <div className="summary-cards">
        <div className="summary-card">
          <div className="card-icon">⏱️</div>
          <div className="card-info">
            <h3>۱۲ ساعت</h3>
            <p>زمان مطالعه کل</p>
          </div>
        </div>
        <div className="summary-card">
          <div className="card-icon">📚</div>
          <div className="card-info">
            <h3>۴۲</h3>
            <p>درس تکمیل شده</p>
          </div>
        </div>
        <div className="summary-card">
          <div className="card-icon">🎮</div>
          <div className="card-info">
            <h3>۶۷</h3>
            <p>بازی انجام شده</p>
          </div>
        </div>
        <div className="summary-card">
          <div className="card-icon">🏆</div>
          <div className="card-info">
            <h3>۲۳</h3>
            <p>دستاورد کسب شده</p>
          </div>
        </div>
      </div>

      {/* کودکان */}
      <section className="children-section">
        <div className="section-header">
          <h2>کودکان من</h2>
          <button className="add-button" onClick={handleAddChild}>
            + افزودن کودک جدید
          </button>
        </div>
        
        <div className="children-grid">
          {children.map(child => (
            <div key={child.id} className="child-card">
              <div className="child-avatar">
                {child.avatar}
              </div>
              <div className="child-info">
                <h3>{child.name}</h3>
                <div className="child-details">
                  <p>سن: {child.age} سال</p>
                  <p>سطح: {child.level}</p>
                  <p>عضویت: {child.joinedDate}</p>
                  <p>آخرین فعالیت: {child.lastActive}</p>
                </div>
              </div>
              <div className="child-progress">
                <div className="progress-bar">
                  <div 
                    className="progress-fill"
                    style={{ width: `${child.progress}%` }}
                  ></div>
                </div>
                <span className="progress-text">{child.progress}% پیشرفت</span>
                <button 
                  className="view-details-button primary-button"
                  onClick={() => handleViewDetails(child)}
                >
                  مشاهده جزئیات
                </button>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* دستاوردهای اخیر */}
      <section className="achievements-section">
        <h2>دستاوردهای اخیر</h2>
        <div className="achievements-list">
          {achievements.map(achievement => (
            <div key={achievement.id} className="achievement-item">
              <div className="achievement-icon">{achievement.icon}</div>
              <div className="achievement-info">
                <h4>{achievement.title}</h4>
                <p>توسط {achievement.child} در {achievement.date}</p>
                <span className="achievement-points">+{achievement.points} امتیاز</span>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  )

  const renderReports = () => (
    <div className="reports-content">
      <h2>گزارش‌های هفتگی</h2>
      
      <div className="reports-grid">
        {weeklyReportsData.map((report, index) => (
          <div key={index} className="report-card">
            <div className="report-header">
              <h3>{report.week}</h3>
              <span className="improvement">{report.improvement}</span>
            </div>
            <div className="report-stats">
              <div className="report-stat">
                <span className="stat-label">⏱️ زمان مطالعه</span>
                <span className="stat-value">{report.studyTime}</span>
              </div>
              <div className="report-stat">
                <span className="stat-label">📚 دروس تکمیل شده</span>
                <span className="stat-value">{report.lessonsCompleted}</span>
              </div>
              <div className="report-stat">
                <span className="stat-label">🎮 بازی‌های انجام شده</span>
                <span className="stat-value">{report.gamesPlayed}</span>
              </div>
              <div className="report-stat">
                <span className="stat-label">🧩 پازل‌های حل شده</span>
                <span className="stat-value">{report.puzzlesSolved}</span>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* نمودار پیشرفت */}
      <section className="progress-chart">
        <h3>نمودار پیشرفت ماهانه</h3>
        <div className="chart-container">
          <div className="chart-bars">
            {progressData.labels.map((label, index) => (
              <div key={label} className="chart-column">
                <div className="bar-group">
                  <div 
                    className="bar lessons-bar"
                    style={{ height: `${progressData.lessons[index] * 2}px` }}
                    title={`${progressData.lessons[index]} درس`}
                  ></div>
                  <div 
                    className="bar games-bar"
                    style={{ height: `${progressData.games[index] * 2}px` }}
                    title={`${progressData.games[index]} بازی`}
                  ></div>
                  <div 
                    className="bar puzzles-bar"
                    style={{ height: `${progressData.puzzles[index] * 2}px` }}
                    title={`${progressData.puzzles[index]} پازل`}
                  ></div>
                </div>
                <span className="chart-label">{label}</span>
              </div>
            ))}
          </div>
          <div className="chart-legend">
            <div className="legend-item">
              <div className="legend-color lessons-color"></div>
              <span>دروس</span>
            </div>
            <div className="legend-item">
              <div className="legend-color games-color"></div>
              <span>بازی‌ها</span>
            </div>
            <div className="legend-item">
              <div className="legend-color puzzles-color"></div>
              <span>پازل‌ها</span>
            </div>
          </div>
        </div>
      </section>
    </div>
  )

  const renderSettings = () => (
    <div className="settings-content">
      <h2>تنظیمات parental</h2>
      
      <div className="settings-grid">
        <div className="setting-group">
          <h3>⏰ محدودیت زمانی</h3>
          <div className="setting-option">
            <label>حداکثر زمان استفاده روزانه</label>
            <select 
              value={timeLimit}
              onChange={(e) => setTimeLimit(parseInt(e.target.value))}
            >
              <option value={30}>۳۰ دقیقه</option>
              <option value={45}>۴۵ دقیقه</option>
              <option value={60}>۱ ساعت</option>
              <option value={90}>۱.۵ ساعت</option>
              <option value={120}>۲ ساعت</option>
            </select>
            <p className="setting-description">
              کودک شما می‌تواند حداکثر {timeLimit} دقیقه در روز از برنامه استفاده کند.
            </p>
          </div>
        </div>

        <div className="setting-group">
          <h3>🔔 اعلان‌ها</h3>
          <div className="setting-option">
            <label>
              <input 
                type="checkbox" 
                checked={notifications}
                onChange={(e) => setNotifications(e.target.checked)}
              />
              دریافت اعلان‌های پیشرفت
            </label>
            <p className="setting-description">
              هنگامی که کودک شما دستاورد جدیدی کسب می‌کند، مطلع شوید.
            </p>
          </div>
          
          <div className="setting-option">
            <label>
              <input 
                type="checkbox" 
                checked={weeklyReports}
                onChange={(e) => setWeeklyReports(e.target.checked)}
              />
              دریافت گزارش هفتگی ایمیلی
            </label>
            <p className="setting-description">
              خلاصه‌ای از فعالیت‌های هفتگی کودک خود را دریافت کنید.
            </p>
          </div>
        </div>

        <div className="setting-group">
          <h3>🎯 اهداف آموزشی</h3>
          <div className="setting-option">
            <label>تعداد درس‌های هفتگی هدف</label>
            <select defaultValue={5}>
              <option value={3}>۳ درس در هفته</option>
              <option value={5}>۵ درس در هفته</option>
              <option value={7}>۷ درس در هفته</option>
            </select>
          </div>
          
          <div className="setting-option">
            <label>تعداد پازل‌های روزانه هدف</label>
            <select defaultValue={5}>
              <option value={3}>۳ پازل در روز</option>
              <option value={5}>۵ پازل در روز</option>
              <option value={10}>۱۰ پازل در روز</option>
            </select>
          </div>
        </div>

        <div className="setting-group">
          <h3>👁️ نظارت</h3>
          <div className="setting-option">
            <label>
              <input type="checkbox" defaultChecked />
              امکان مشاهده بازی‌های انجام شده
            </label>
          </div>
          <div className="setting-option">
            <label>
              <input type="checkbox" defaultChecked />
              امکان مشاهده نتایج آزمون‌ها
            </label>
          </div>
          <div className="setting-option">
            <label>
              <input type="checkbox" defaultChecked />
              امکان مشاهده زمان استفاده
            </label>
          </div>
        </div>
      </div>

      <div className="settings-actions">
        <button className="primary-button large">
          💾 ذخیره تنظیمات
        </button>
        <button className="secondary-button">
          🔄 بازنشانی به پیش‌فرض
        </button>
      </div>
    </div>
  )

  const tabs = [
    { id: 'overview', label: 'نمای کلی', icon: '📊' },
    { id: 'reports', label: 'گزارش‌ها', icon: '📈' },
    { id: 'settings', label: 'تنظیمات', icon: '⚙️' }
  ]

  return (
    <div className="parents-page">
      <div className="parents-container">
        <header className="parents-header">
          <div className="header-content">
            <h1>پنل والدین</h1>
            <p>پیگیری پیشرفت و مدیریت حساب کودکان</p>
          </div>
          <div className="header-stats">
            <div className="stat">
              <span className="stat-value">{children.length}</span>
              <span className="stat-label">کودک فعال</span>
            </div>
            <div className="stat">
              <span className="stat-value">۸۵٪</span>
              <span className="stat-label">میانگین پیشرفت</span>
            </div>
          </div>
        </header>

        {/* تب‌های ناوبری */}
        <nav className="parents-tabs">
          {tabs.map(tab => (
            <button
              key={tab.id}
              className={`tab-button ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => setActiveTab(tab.id)}
            >
              <span className="tab-icon">{tab.icon}</span>
              {tab.label}
            </button>
          ))}
        </nav>

        {/* محتوای تب فعال */}
        <div className="tab-content">
          {activeTab === 'overview' && renderOverview()}
          {activeTab === 'reports' && renderReports()}
          {activeTab === 'settings' && renderSettings()}
        </div>

        {/* نکات آموزشی */}
        <section className="educational-tips">
          <h3>💡 نکات آموزشی برای والدین</h3>
          <div className="tips-grid">
            <div className="tip-card">
              <h4>تشویق مستمر</h4>
              <p>کودک خود را برای هر پیشرفت کوچکی تشویق کنید.</p>
            </div>
            <div className="tip-card">
              <h4>تعادل زمانی</h4>
              <p>بین زمان یادگیری و بازی تعادل برقرار کنید.</p>
            </div>
            <div className="tip-card">
              <h4>همراهی در یادگیری</h4>
              <p>گاهی در کنار کودک خود بنشینید و با هم یاد بگیرید.</p>
            </div>
            <div className="tip-card">
              <h4>هدف‌گذاری واقعی</h4>
              <p>اهداف قابل دسترسی و متناسب با سن کودک تعیین کنید.</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  )
}

export default ParentsPage